import { render, staticRenderFns } from "./yiFangDj.vue?vue&type=template&id=97e4eea6&scoped=true"
import script from "./yiFangDj.vue?vue&type=script&lang=js"
export * from "./yiFangDj.vue?vue&type=script&lang=js"
import style0 from "./yiFangDj.vue?vue&type=style&index=0&id=97e4eea6&prod&lang=css"
import style1 from "./yiFangDj.vue?vue&type=style&index=1&id=97e4eea6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e4eea6",
  null
  
)

export default component.exports